import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { useConfig } from '../../config';
import { isInSystemMaintenance } from '../../models/config';
import { fromAuth } from '../../store';
import { ReactComponent as MaintenanceIcon } from './maintenance-icon.svg';
import { ReactComponent as WarningIcon } from './warning-icon.svg';

const useStyles = makeStyles(theme => ({
  warningBanner: {
    background: '#FFF8EE',
    border: '2px solid #FFA876',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'start',
  },
  message: {
    marginLeft: theme.spacing(3),
    flex: 1,
  },
  warningIcon: {
    marginLeft: theme.spacing(3),
  },
  statusLink: {
    textDecoration: 'none',
  },
}));

const ReadOnlyWarningBanner = () => {
  const classes = useStyles();
  const { config } = useConfig();
  const intl = useIntl();
  const didLogin = useSelector(fromAuth.selectDidLogin);
  if (!didLogin || !config?.maintenanceStart) {
    return null;
  }
  return (
    <div className={classes.warningBanner}>
      <WarningIcon className={classes.warningIcon} />
      <span className={classes.message}>
        <FormattedMessage
          id={
            isInSystemMaintenance(config)
              ? 'message.system_maintenance_mode'
              : 'message.system_maintenance_mode_warning'
          }
          values={{
            maintenanceDate: new Intl.DateTimeFormat(
              'default',
              {
                year: 'numeric', month: 'short', day: '2-digit',
              },
            ).format(config.maintenanceStart),
            maintenanceTime: new Intl.DateTimeFormat(
              'default',
              {
                hour: '2-digit', minute: '2-digit', timeZoneName: 'short',
              },
            ).format(config.maintenanceStart),
            maintenanceDateGMT: new Intl.DateTimeFormat(
              'default',
              {
                year: 'numeric', month: 'short', day: '2-digit', timeZone: 'UTC',
              },
            ).format(config.maintenanceStart),
            maintenanceTimeGMT: new Intl.DateTimeFormat(
              'default',
              {
                hour: '2-digit', minute: '2-digit', timeZone: 'UTC', timeZoneName: 'short',
              },
            ).format(config.maintenanceStart),
            statusLink: (
              <a
                href="https://status.katalon.com"
                target="_blank"
                rel="noreferrer"
                className={classes.statusLink}
              >
                {intl.formatMessage({ id: 'message.system_maintenance_mode_warning.this_page' })}
              </a>
            ),
          }}
        />
      </span>
      <MaintenanceIcon />
    </div>
  );
};

export default ReadOnlyWarningBanner;
